export default "__VITE_ASSET__BmW43zqP__"